// Opens the lead-capture dialog.
//
// Everything a modal has to get right — focus trap, Escape, inert background,
// stacking above the rest of the page — is what <dialog>.showModal() already
// does. This is only the opening and closing.
(function () {
  if (window.__pruvitBlueprint) return;
  window.__pruvitBlueprint = true;

  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-pruvit-bp-open]');
    if (open) {
      var dialog = document.getElementById(open.getAttribute('aria-controls'));
      // showModal is what puts it in the top layer and makes the rest inert;
      // open=true would render it in flow with none of that.
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }
      return;
    }

    var close = event.target.closest('[data-pruvit-bp-close]');
    if (close) {
      var owner = close.closest('dialog');
      if (owner) owner.close();
    }
  });

  // Clicking the backdrop closes it. The dialog element itself covers only the
  // panel, so a click whose target *is* the dialog landed outside the panel.
  document.addEventListener('click', function (event) {
    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('pruvit-bp__dialog')) {
      event.target.close();
    }
  });

  // ---- opening it by itself -------------------------------------------------
  //
  // Craig, 2026-09-24: exit intent on desktop, scroll depth on mobile. Two
  // triggers because the gesture that means "I am leaving" is different on each
  // — a pointer heading for the browser chrome, versus having read far enough
  // to have formed an opinion. A phone has no pointer to read and a desktop
  // reader's scroll says much less, so neither trigger is worth running on the
  // other's device.
  //
  // Split on the POINTER, not the width, the same way the header's hover menu
  // is: a touchscreen laptop reports a wide viewport and has no mouse to leave
  // with, so it should get the scroll trigger.
  //
  // Everything below exists to make an interruption defensible. The band this
  // dialog belongs to argues that the reader is not leaving yet; a modal that
  // fires on every page load argues the opposite, loudly.

  var root = document.querySelector('[data-pruvit-bp-auto]');
  if (!root) return;

  var cfg = {
    depth: parseInt(root.dataset.depth, 10) || 60,
    delay: (parseInt(root.dataset.delay, 10) || 8) * 1000,
    cooldown: (parseInt(root.dataset.cooldown, 10) || 7) * 86400000,
  };
  var dialog = document.getElementById(root.dataset.dialog || '');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  // localStorage, with an in-memory fallback. It throws in a private window and
  // comes back empty when site data is cleared, and neither is a reason to
  // either spam the visitor or never ask. Failing to memory means the worst
  // case is once per page load, which is what a first-time visitor gets anyway.
  var KEY = 'pruvit:bp:auto';
  var memory = null;
  var readState = function () {
    try {
      return JSON.parse(localStorage.getItem(KEY) || 'null') || memory || {};
    } catch (e) {
      return memory || {};
    }
  };
  var writeState = function (next) {
    memory = next;
    try {
      localStorage.setItem(KEY, JSON.stringify(next));
    } catch (e) {}
  };

  var fired = false;
  var landed = Date.now();

  // Any open counts, including one the visitor asked for. Someone who opened it
  // themselves has seen the offer, and following them around with it afterwards
  // is the behaviour this cooldown exists to prevent.
  var markSeen = function () {
    var state = readState();
    state.seen = Date.now();
    writeState(state);
  };
  dialog.addEventListener('close', markSeen);
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-pruvit-bp-open]')) markSeen();
  });

  // Converted is forever. Asking again for an address already given is the
  // worst version of this pattern.
  document.addEventListener('pruvit:lead:done', function () {
    var state = readState();
    state.done = 1;
    writeState(state);
    fired = true;
  });

  var eligible = function () {
    if (fired || dialog.open) return false;

    var state = readState();
    if (state.done) return false;
    if (state.seen && Date.now() - state.seen < cfg.cooldown) return false;

    // Long enough on the page to have seen something. Without this, a pointer
    // travelling to a bookmark two seconds after landing gets a modal about a
    // page nobody has read.
    if (Date.now() - landed < cfg.delay) return false;

    // Never on top of something else. The cart, the menu, the options panel and
    // the referrer modal are all things the visitor opened on purpose, and this
    // one did not.
    if (document.querySelector('dialog[open]')) return false;
    if (document.querySelector('.pruvit-menu.is-open, .pruvit-cart.is-open, .pruvit-opt.is-open')) return false;

    // Not while they are typing. Stealing focus mid-field loses whatever was
    // being typed and is the one version of this that is genuinely damaging.
    var active = document.activeElement;
    if (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) return false;

    return true;
  };

  var open = function () {
    if (!eligible()) return;
    fired = true;
    markSeen();
    dialog.showModal();
  };

  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

  if (fine.matches) {
    // Exit intent: the pointer leaves the document through the TOP. A null
    // relatedTarget is what says it left the window rather than moving between
    // two elements, and clientY <= 0 is what distinguishes the browser chrome
    // from the pointer sliding out of the left, right or bottom edge — none of
    // which means leaving.
    document.addEventListener('mouseout', function (event) {
      if (event.relatedTarget || event.clientY > 0) return;
      open();
    });
  } else {
    // Scroll depth. Below 990px the document is the scroller — above it the
    // page-wrapper is, but that is the branch this trigger does not run on.
    var ticking = false;
    var onScroll = function () {
      if (ticking || fired) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var doc = document.scrollingElement || document.documentElement;
        var reach = doc.scrollHeight - doc.clientHeight;
        if (reach <= 0) return;
        var pct = ((doc.scrollTop + doc.clientHeight) / doc.scrollHeight) * 100;
        if (pct >= cfg.depth) open();
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
